import Vue from 'vue';
import App from './components/App.vue';
import GlobalMixin from './mixins/globalMixin.js';

window.LocatorConfig = window.LocatorConfig || {};

Vue.config.productionTip = false;

Vue.mixin(GlobalMixin);

new Vue({
    render: (h) => h(App)
}).$mount('#locator-app');
